import { render, staticRenderFns } from "./payslipitemedit.vue?vue&type=template&id=24dec450&scoped=true"
import script from "./payslipitemedit.vue?vue&type=script&lang=js"
export * from "./payslipitemedit.vue?vue&type=script&lang=js"
import style0 from "./payslipitemedit.vue?vue&type=style&index=0&id=24dec450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dec450",
  null
  
)

export default component.exports